var React = require('react');

function SoundOff (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.515 7.974a4.5 4.5 0 00-4.663.389L10.065 16.5H4.502a4.501 4.501 0 00-4.5 4.5v6c0 2.484 2.016 4.5 4.5 4.5h5.563l12.788 8.138A4.5 4.5 0 0030.002 36V12a4.502 4.502 0 00-2.487-4.026zM24.603 10.8a1.5 1.5 0 012.399 1.2v24a1.5 1.5 0 01-2.4 1.2 1.481 1.481 0 00-.095-.065l-12.505-7.958V18.823l12.505-7.957a1.49 1.49 0 00.096-.067zM9.002 19.5h-4.5a1.5 1.5 0 00-1.5 1.5v6a1.5 1.5 0 001.5 1.5h4.5v-9z","key":0}),React.createElement("path",{"d":"M47.559 17.69a1.5 1.5 0 010 2.12L43.369 24l4.19 4.19a1.5 1.5 0 01-2.122 2.12l-4.189-4.189-4.19 4.19a1.5 1.5 0 01-2.12-2.122L39.126 24l-4.19-4.19a1.5 1.5 0 012.122-2.12l4.189 4.189 4.19-4.19a1.5 1.5 0 012.12 0z","key":1})]);
}

SoundOff.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SoundOff;

SoundOff.default = SoundOff;
